import { useTranslation } from 'react-i18next';
import { Button } from '../UI/base/Button';
import SaveIcon from '../../assets/icons/save.svg?react';
import { selectHasPendingChanges } from '../../store/application/applicationSlice';
import { useAppSelector } from '../../store/hooks';
import styles from './GanttEditToolbar.module.css';

interface EditActionsProps {
  visible: boolean;
  onDiscard: () => void | Promise<void>;
  onAccept: () => void | Promise<void>;
}

export const EditActions = ({ visible, onDiscard, onAccept }: EditActionsProps) => {
  const { t } = useTranslation();
  // The plan's edits and the year target both count: a target typed in on its own
  // used to leave this greyed out, with Discard as the only way out of edit mode.
  const hasPendingChanges = useAppSelector(selectHasPendingChanges);

  return (
    <div className={`${styles.editActions} ${visible ? styles.editActionsVisible : ''}`}>
      <Button type="tertiary" onClick={onDiscard}>
        {t('edit-plan-discard')}
      </Button>
      <Button
        type="primary"
        icon={<SaveIcon />}
        onClick={onAccept}
        disabled={!hasPendingChanges}
        styles={{ root: { gap: 4, padding: 12 } }}
      >
        {t('edit-plan-accept')}
      </Button>
    </div>
  );
};
